import { Typography } from '@material-ui/core';
import Breadcrumb from '../Breadcrumb';
import ReviewDocument1 from './../../assets/ReviewDocument-1.png';
import ReviewDocument10 from './../../assets/ReviewDocument-10.png';
import ReviewDocument2 from './../../assets/ReviewDocument-2.png';
import ReviewDocument3 from './../../assets/ReviewDocument-3.png';
import HelpFooter from './HelpFooter';
import useStyles from './useStyles';
import { useTranslation } from 'react-i18next';

export default function ReviewDocument() {
  const classes = useStyles();
  const { t } = useTranslation();
  return (
    <div className={classes.root}>
      <Breadcrumb
        name="topicName"
        data={{
          helpTopic: t('help.topics.documents.label'),
          helpTopicId: 'documents',
          topicName: t('help.subtopics.reviewApproveDocument'),
          topicNameId: 'review-approve-document'
        }}
      />
      <Typography className={classes.title} component="p" variant="h4">
        {t('help.pages.reviewDocument.title')}
      </Typography>
      <Typography variant="body1">{t('help.pages.reviewDocument.step1')}</Typography>
      <img className={classes.media} src={ReviewDocument1} alt={`${String(t('help.stepAltPrefix'))}1`} />
      <Typography variant="body1">{t('help.pages.reviewDocument.step2')}</Typography>
      <img className={classes.media} src={ReviewDocument2} alt={`${String(t('help.stepAltPrefix'))}2`} />
      <Typography variant="body1">{t('help.pages.reviewDocument.step3')}</Typography>
      <Typography variant="body2">{t('help.pages.reviewDocument.note1')}</Typography>
      <img className={classes.media} src={ReviewDocument3} alt={`${String(t('help.stepAltPrefix'))}3`} />
      <Typography variant="h6" color="primary">{t('help.pages.reviewDocument.pmExternalTitle')}</Typography>
      <Typography variant="body1">{t('help.pages.reviewDocument.pmExternalDesc')}</Typography>
      <Typography className={classes.textLeftMargin} variant="body2">
        <u>{t('help.approvalCodeDefinition')}</u>
      </Typography>
      <Typography className={classes.textLeftMargin} variant="body2">
        {t('help.approvalCodes.A1')}
      </Typography>
      <Typography className={classes.textLeftMargin} variant="body2">
        {t('help.approvalCodes.A2')}
      </Typography>
      <Typography className={classes.textLeftMargin} variant="body2">
        {t('help.approvalCodes.A3')}
      </Typography>
      <Typography className={classes.textLeftMargin} variant="body2">
        {t('help.approvalCodes.A4')}
      </Typography>
      <Typography className={classes.textLeftMargin} variant="body2">
        {t('help.approvalCodes.A5')}
      </Typography>
      <img className={classes.media} src={ReviewDocument10} alt={`${String(t('help.stepAltPrefix'))}10`} />
      <HelpFooter />
    </div>
  );
}
